export default "__VITE_ASSET__D4pID$Uc__"